import styled from 'styled-components';
import { color, duration, ease, font, radius, shadow } from '../../../theme/tokens';
import { reducedMotion, shake } from '../../atome/motion/motion.styled';

export const SignInWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* Sideways reveals live inside this page, and nothing else here clips them. */
  overflow-x: clip;
  background:
    radial-gradient(70% 60% at 50% 0%, ${color.sandLight} 0%, transparent 60%),
    ${color.cream};
`;

export const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 1.25rem;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 27rem;
  padding: 2.8rem 2.4rem 2.4rem;
  border-radius: ${radius.xl};
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.85);
  box-shadow: ${shadow.lift};

  h1 {
    font-family: ${font.display};
    font-size: clamp(1.9rem, 5vw, 2.4rem);
    font-weight: 600;
    line-height: 1.12;
    color: ${color.ink};
    margin: 1rem 0 0.4rem;
  }

  > p {
    font-family: ${font.body};
    font-size: 0.92rem;
    line-height: 1.7;
    color: ${color.inkSoft};
    margin: 0 0 1.8rem;
  }

  @media (max-width: 600px) {
    padding: 2.2rem 1.35rem 1.9rem;
  }
`;

export const SubmitButton = styled.button`
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: 0.4rem;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: ${radius.pill};
  cursor: pointer;
  font-family: ${font.body};
  font-size: 0.98rem;
  font-weight: 500;
  letter-spacing: 0.05em;
  color: #fff;
  background: ${color.forest};
  box-shadow: 0 16px 34px rgba(74, 112, 97, 0.26);
  transition:
    transform ${duration.base} ${ease.spring},
    background ${duration.base} ${ease.out};

  &:hover:not(:disabled) {
    background: ${color.forestDeep};
    transform: translateY(-3px);
  }

  &:disabled {
    background: ${color.sandDeep};
    cursor: not-allowed;
    box-shadow: none;
  }

  ${reducedMotion};
`;

export const ErrorBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1.2rem;
  padding: 0.85rem 1.05rem;
  border-radius: ${radius.md};
  background: rgba(180, 84, 74, 0.09);
  border: 1px solid rgba(180, 84, 74, 0.28);
  color: ${color.danger};
  font-family: ${font.body};
  font-size: 0.86rem;
  line-height: 1.5;
  animation: ${shake} 0.45s ${ease.out};

  svg {
    flex: 0 0 auto;
  }

  ${reducedMotion};
`;

export const BackLink = styled.button`
  display: block;
  margin: 1.4rem auto 0;
  padding: 0.4rem;
  border: none;
  background: none;
  cursor: pointer;
  font-family: ${font.body};
  font-size: 0.8rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${color.inkFaint};
  transition: color ${duration.fast} ${ease.out};

  &:hover {
    color: ${color.forest};
  }
`;
